import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AUTH_SERVICE_API_ROUTES } from './auth-service-routes';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	constructor(private http: HttpClient) {}

	public postPassword(partyId: string, password: string): Observable<any> {
		const headers = new HttpHeaders()
			.set('partyId', partyId)
			.set('accessToken', '');

		return this.http.post(
			AUTH_SERVICE_API_ROUTES.postPassword,
			{ password },
			{ headers }
		);
	}
}
